import React, { useEffect, useState } from "react";
import Headers from "../Common/Headers";
import { getAPIUrlBM } from "../../../utils/config";
// import Get from "../../../Apis/backlink/Get";
import Post from "../../../Apis/backlink/Post";
import "../Lists/style.css";
// import ListTable from "../../utils/ListTable/ListTable";
// import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import favicon from "../Assets/Favicon.png";
import loadingGif from "../Assets/loading.gif";
// import ogImage from "../Assets/og_backLink.png";
import TablePagination from "../../utils/TablePagination/TablePagination";
// import DeleteIcon from "../Assets/DeleteIcon";
// import DeleteIcon from "../Assets/DeleteIcon";
import CrossIcon from "../Assets/CrossIcon";
import { useContext } from "react";
import LimitsContext from "../../../contextApi/backlink/LimitsContext";
import FindBacklinks from "../popup/FindBacklinks";
import RouteChecker from "../../utils/RouteChecker";

function Domain() {
  const [searched, setSearched] = useState(null);
  const [isloading, setIsloading] = useState(false);
  const [domain, setDomain] = useState();
  const {
    // domainCount,
    getDomainCount,
  } = useContext(LimitsContext);
  // const navigate = useNavigate();
  // const params = useParams();

  const [rowsPerPage, setRowsPerPage] = useState(
    localStorage.getItem("rowsPerPageInList") || 50,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [open, setOpen] = useState(false);

  const requestSearch = async () => {
    try {
      // setIsloading(true);
      const url = getAPIUrlBM();
      const res = await Post(url + `/fetchDomain`, {
        search: searched ?? "",
        limit: rowsPerPage ?? 0,
        page: currentPage ?? 0,
      });
      console.log(res);

      if (currentPage - 1 === 0) setTotalRows(parseInt(res.countPage[0].count));
      setDomain(res.response);
      // setIsloading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    requestSearch();
  }, [rowsPerPage, currentPage]);
  const header = {
    heading: "Domain",
    link: "http://links.backlinkchecker.info/list-tutorial",
    subHeading: "You can add domains for which you are monitoring backlinks.",
    description:
      "Domains are automatically added when you add a new backlinks.",
    isSubHeading: true,
  };

  const getDomainByName = async () => {
    try {
      const url = getAPIUrlBM();
      const res = await Post(url + `/fetchDomain`, {
        search: document.getElementById("search").value ?? "",
        limit: rowsPerPage ?? 0,
        page: 1,
      });
      console.log(res);

      setTotalRows(parseInt(res.countPage[0].count));
      setDomain(res.response);
    } catch (error) {
      console.log(error);
    }
  };

  const addNewDomain = async () => {
    try {
      const url = getAPIUrlBM();
      const res = await Post(url + `/add/domain`, {
        domain: document.getElementById("newdomain").value ?? "",
      });
      console.log(res);
      window.sweet({
        text: res.message,
      });
      if (res.status === 200) {
        requestSearch();
        document.getElementById("newdomain").value = "";
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const [deleteAll, setDeleteAll] = useState(false);
  const [deleteDomain, setDeleteDomain] = useState(false);

  const deleteDomainByDomain = async (domain) => {
    try {
      const url = getAPIUrlBM();
      const res = await Post(url + `/deleteDomain`, {
        domainId: domain,
      });
      setDeleteDomain(false);
      if (res.var === "limit") {
        return window.sweet({
          title: "Upgrade Plan",
          text: res.message,
          icon: "error",
        });
      }
      getDomainCount();
      requestSearch();
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Helmet>
        <title>Lists - Backlink Checker</title>
        <meta
          name="description"
          content="You can define monitoring schedule, list subscribers & public URL at list level"
        />
        {/* <meta property="og:image" key="og:image" content={ogImage} /> */}
        {/* <meta property="og:url" content="https://app.linkly.digital/lists" /> */}
        <meta property="og:title" content="Lists - Backlink Checker" />
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        <meta
          property="og:description"
          content="You can define monitoring schedule, list subscribers & public URL at list level"
        />
        {/* <meta property="og:image" key="og:image" content={"/og_backLink.jpg"} /> */}
      </Helmet>
      <RouteChecker url="domainScreen">
        {!isloading ? (
          <>
            <div className="subMainContainer">
              <Headers header={header} />

              <div className="listBody">
                <div>
                  <p> Search</p>
                  <input
                    type="text"
                    id="search"
                    value={searched}
                    placeholder="Search list by name"
                    className="searchField"
                    //   onChange={(e) => setSearched(e.target.value)}
                  />
                  <button onClick={getDomainByName} className="successButton">
                    Search
                  </button>
                </div>
                <div
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <p>Add New Domain</p>
                  <input
                    type="text"
                    id="newdomain"
                    value={searched}
                    placeholder="Add New Domain"
                    className="searchField"
                    //   onChange={(e) => setSearched(e.target.value)}
                  />
                  <button onClick={addNewDomain} className="successButton">
                    Add New Domain
                  </button>
                </div>
                <div className="domainTable">
                  <div className="domainTable-rows">
                    <div className="domainTable-row domainTable-header-row">
                      <div className="domainTable-row-col1 domainTable-header">
                        Domain ( Link To )
                      </div>
                      <div className="domainTable-row-col2 domainTable-header">
                        Count
                      </div>
                      <div className="domainTable-row-col2 find-button-header domainTable-header ml-2">
                        Delete
                      </div>
                      <div className="domainTable-row-col2 find-button-header domainTable-header ">
                        Find Backlinks
                      </div>
                    </div>
                    {domain?.map((item, index) => {
                      return (
                        <div className="domainTable-row">
                          <div className="domainTable-row-col1">
                            {item.domain}
                            <a
                              href={`http://${item?.domain}`}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              <img
                                src={"../new_window_black.svg"}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  marginLeft: "10px",
                                }}
                                alt=""
                              />
                            </a>
                          </div>
                          <div className="domainTable-row-col2 ml-2">
                            {item.count}
                          </div>
                          <div className="domainTable-row-col2 ml-2 ">
                            <button
                              onClick={() => setDeleteDomain(item.id)}
                              className="btn btn-danger font-weight-bold"
                            >
                              Delete
                            </button>
                          </div>
                          <div
                            className="domainTable-row-col2 find-button"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => setOpen(item?.domain)}
                          >
                            Find backlinks
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              {open && (
                <FindBacklinks
                  handleClose={() => {
                    setOpen(false);
                  }}
                  domain={open}
                />
              )}
              {deleteDomain && (
                <div
                  className="domainDeleteModel"
                  onClick={(event) => {
                    const inside = document.getElementById(
                      "domainDeleteModel-container",
                    );
                    if (
                      inside !== event.target &&
                      !inside.contains(event.target)
                    ) {
                      setDeleteDomain(false);
                    }
                  }}
                >
                  <div className="domainDeleteModel-backdrop"></div>
                  <div
                    className="domainDeleteModel-container"
                    id="domainDeleteModel-container"
                  >
                    <span
                      style={{
                        position: "absolute",
                        right: "20px",
                        top: "15px",
                        cursor: "pointer",
                      }}
                      onClick={() => setDeleteDomain(false)}
                    >
                      <CrossIcon />
                    </span>
                    <h4>Alert ! Domain will be deleted</h4>
                    <p>The links & its logs will not be deleted.</p>
                    <p>
                      Please delete them from List dashboard
                      manually if you wish to.
                    </p>

                    <div className="deleteButtonForDomainDeletion">
                      <button
                        onClick={() => {
                          deleteDomainByDomain(deleteDomain);
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <TablePagination
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalRows={totalRows}
              bgColor={"#f9fafb"}
            />
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "89vh",
              margin: "-15px -30px",
            }}
          >
            <img
              style={{
                width: "82vw",
                height: "94vh",
              }}
              alt=""
              src={loadingGif}
            />
          </div>
        )}
      </RouteChecker>
    </div>
  );
}

export default Domain;
